import type { GroupBase, MultiValueRemoveProps } from 'react-select-5';

import Close from 'components/shared/Icon/icons/Close';

export function MultiValueRemove<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MultiValueRemoveProps<Option, IsMulti, Group>,
) {
  const { innerProps } = props;
  return (
    <div {...innerProps}>
      <Close width="10" height="10" strokeWidth={2} />
    </div>
  );
}
